import { useContext } from "react";
import { ImpersonationContext } from "@/contexts/ImpersonationContext";

export function useImpersonation() {
  const context = useContext(ImpersonationContext);
  if (!context) {
    throw new Error(
      "useImpersonation must be used within an ImpersonationProvider"
    );
  }
  return context;
}
